define('gameday-index-enums/enums/baseball/GameStates',{
	// game states published by the DFE
	IN_PROGRESS: "In Progress",
	REPLAY: "Replay",
	WARMUP: "Warmup",
	PREVIEW: "Preview",
	PREGAME: "Pre-Game",
	FINAL: "Final",
	GAME_OVER: "Game Over",
	COMPLETED_EARLY: "Completed Early",
	DELAYED: "Delayed",
	DELAYED_START: "Delayed Start",
	SUSPENDED: "Suspended",
	POSTPONED: "Postponed",
	FORFEIT: "Forfeit",
	CANCELLED: "Cancelled",
	REVIEW: "Review",
	CHALLENGE: "Manager Challenge",

	// display states shown by resolution inside the app
	LIVE: "Live",
	INSTANT_REPLAY: "Instant Replay",
	LINEUPS: "Lineups",

	// STATES as used by the previous RESPONSIVE GAMEDAY CODE
	RE_PREGAME: "Pregame",
	RE_SUSPENDED: "Suspended",
	RE_PITCH: "Live",
	RE_LIVE: "Live",
	RE_WRAPUP: "Wrapup",

	// abstract states, which are resolved by grouping
	// the more discreet states into buckets
	ABSTRACT_PREGAME: "abstractPregame",
	ABSTRACT_LIVE: "abstractLive",
	ABSTRACT_DELAYED: "abstractDelayed",
	ABSTRACT_FINAL: "abstractFinal",
	ABSTRACT_OTHER: "abstractOther"
});
